// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2cw4K","filesListContainer":"PosDisputesFiles_filesListContainer__34YMO","filesButton":"PosDisputesFiles_filesButton__zArdU"};